import axios from "@/plugins/axios";

let url = (data) => "/api/v1/shop/orders/${_id}/process".interpolate(data);

export default {
    post(data) {
        return axios.post(url(data), data).then((result) => result.data);
    },
};
